import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class CurrencyApis {
    exchangeRate = async currencyNicName => await axiosIns.get(`currency/rate/${currencyNicName}`)

    currencies = async data => await axiosIns.get(`currencies/${objectToUrlParam(data)}`)

    currencyPrice = async data => await axiosIns.get(`wallet/currency/price${objectToUrlParam(data)}`)
}
